<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div />
</template>
<script>

export default {
  components: {},
  data() {
    return {
    };
  },
  mounted() {},
  methods: {
  },
};
</script>

<style lang='less' scoped>

</style>
